import React from 'react';
import { Heading, IconCheckmark, IconClose } from '../../components';

import css from './ProfilePage.module.css';

const SectionBooleanMaybe = props => {
  const { boolean, heading, label } = props;

  // Temporary logging to debug boolean field

  // Don't render if boolean is undefined or null
  if (boolean === undefined || boolean === null) {
    return null;
  }


  return (
    <div className={css.sectionBoolean}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      <div className={css.booleanField}>
        <span className={css.booleanLabel}>{label}</span>
        <span className={css.booleanIcon}>
          {boolean ? (
            <IconCheckmark className={css.checkmarkIcon} />
          ) : (
            <IconClose className={css.crossIcon} />
          )}
        </span>
      </div>
    </div>
  );
};

export default SectionBooleanMaybe; 